import { observer } from "mobx-react-lite";
import useDefaultMapLayer from "../../hooks/useDefaultMapLayer";
import { ILayerWithAbilityToOverrideIsStyleLoadedProps } from "../../interfaces/IlayerProps";

function HybridMapboxBaseMapLayer({ visible, isStyleLoadedOverride }: ILayerWithAbilityToOverrideIsStyleLoadedProps) {
    useDefaultMapLayer(visible, () => [
        "mapbox-satellite-hybrid",
    ], isStyleLoadedOverride);

    return (
        <></>
    );
}

export default observer(HybridMapboxBaseMapLayer);